// extracted by mini-css-extract-plugin
export var cardSelected = "_fj-2";
export var image = "_fj-1";
export var table = "_fj-0";